module.exports = __webpack_public_path__ + "static/media/03_disable_Unfomfortable.960ba5e4.svg";